import { MapPin, Pentagon, Minus, Square } from 'lucide-react'

const EllipseIcon = () => (
  <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="12" rx="10" ry="6" />
  </svg>
)
import { useGeometryStore } from '../../store/geometryStore'
import type { DrawMode } from '../../types/geo'
import { useToast } from '../../hooks/useToast'

const TOOLS: { mode: DrawMode; icon: React.ReactNode; label: string }[] = [
  { mode: 'point', icon: <MapPin size={16} />, label: 'Point' },
  { mode: 'polygon', icon: <Pentagon size={16} />, label: 'Polygon' },
  { mode: 'linestring', icon: <Minus size={16} />, label: 'Line' },
  { mode: 'bbox', icon: <Square size={16} />, label: 'BBox' },
  { mode: 'ellipse', icon: <EllipseIcon />, label: 'Ellipse' },
]

export default function DrawingToolbar() {
  const { interactionMode, setInteractionMode, isDrawing } = useGeometryStore()
  const { toast } = useToast()

  function selectMode(mode: DrawMode) {
    if (interactionMode === mode) {
      setInteractionMode('none')
      return
    }
    setInteractionMode(mode)
    const description =
      mode === 'ellipse'
        ? 'Click 1: Center  •  Click 2: Major axis end  •  Click 3: Minor axis end  •  Esc to cancel'
        : 'Click on map to start. Press Esc to cancel.'
    toast({ title: `Draw ${mode}`, description })
  }

  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-10">
      {/* Glass morphism toolbar */}
      <div className="flex gap-1 rounded-lg border border-white/20 bg-black/40 backdrop-blur-md p-1 shadow-xl">
        {TOOLS.map(({ mode, icon, label }) => (
          <button
            key={mode}
            onClick={() => selectMode(mode)}
            title={`${label} (${isDrawing && interactionMode === mode ? 'drawing...' : 'click to activate'})`}
            className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium transition-all
              ${
                interactionMode === mode
                  ? 'bg-blue-500 text-white shadow-lg'
                  : 'text-white/80 hover:bg-white/10 hover:text-white'
              }`}
          >
            {icon}
            <span className="hidden sm:inline">{label}</span>
          </button>
        ))}

        {interactionMode !== 'none' && (
          <div className="ml-2 flex items-center">
            <span className="text-xs text-yellow-300 font-mono animate-pulse">
              {isDrawing ? 'Drawing...' : 'Active'}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
